// eslint-disable-next-line import/named
import { Article } from "../../services/coworkerApiCalls/Article/ArticlesTypes";
import { ArticleFull } from "../article/article";
import "./charterDocument.css";
import { /*useDataApiArticle,*/ useDataApiArticleByCategoryBySpace } from "../../Hooks/useDataArticlesApi";

/**
 * @function CharterDocumentation displays a googledocs of the Coworking charter from the company google drive
 * @returns {JSX.Element} HTML element
 */
function CharterDocumentation() {
  const article: Article = useDataApiArticleByCategoryBySpace(5)!;
  
  //const IsSigned = useDataApiIsSigned(user as User)
  return (
    <>
      {/* the space for the check and sign button is reserved if the user hasn't sign the charter yet*/}
      <ArticleFull {...article} />
    </>
  );
}

export { CharterDocumentation };


